import React from 'react';
import { FindCarrierResponseOutDTO } from '@api/ringil-api.v2';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';

interface ComponentProps {
  carriers: FindCarrierResponseOutDTO[];
}

export const CarrierValidationErrors: React.FC<ComponentProps> = ({
                                                                carriers,
                                                              }) => {
  const { tr } = useTranslationLgs();

  return (
    <>
      {carriers && carriers.length > 0 && (
        <div className="p-4 rounded-lg bg-base-tertiary gap-2">
          <span className="text-complementary-error text-lg font-normal flex flex-row gap-2 items-center">
            {tr('CarrierValidationErrors.title', 'Invalid carriers')}
          </span>
          {carriers.map((carrier) => (
            <div key={carrier.name + carrier.id} className="mb-4">
              <div className="font-semibold">{carrier.name}</div>
              <ul className="list-disc list-inside text-content-secondary">
                {carrier.unavailableMessages?.map((msg, idx) => (
                  <li key={idx}>{tr(msg.translateKey, msg.translateKey)}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </>
  );
};